import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Divider } from '@coolblue-development/freddy';
import { useFormatShortDate } from '@coolblue-development/next-formatting-utils/client';
import { useTranslation } from '../../i18n/useTranslation.js';
export function PreOrderAlert({ expectedReleaseDate }) {
    const { t } = useTranslation('storesStockOverlay.preOrder');
    const releaseDate = useFormatShortDate(new Date(expectedReleaseDate));
    return (_jsxs(_Fragment, { children: [_jsx(Alert, { title: t('title'), description: t('description', { releaseDate }) }), _jsx(Divider, { mt: 400, mb: 400 })] }));
}
//# sourceMappingURL=PreOrderAlert.js.map